(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["frequently-asked-questions"]) return;
  try {
    
  const accordion = document.getElementsByClassName('faq-container');

for (i=0; i<accordion.length; i++) {
  accordion[i].addEventListener('click', function () {
    this.classList.toggle('active')
  })
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information-v2"]) return;
  try {
    
  /* Load Select2 Elements */
  $(function(){
    $('#Quantity').select2();
    $('#product-select-size').select2();
    $(".select2-selection__arrow").remove();
    $(".select2-selection--single").append('<i class="fa fa-angle-down is-active"></i>');

    $('#Quantity').on('select2:select', function(e) {
      // console.log('##### qty change' + $('.select-quantity').val());
      $('.add-to-cart').attr('data-cart-quantity',$('.select-quantity').val());
    });
  })

  /* This function needs to live here so it can use liquid for the differnet country currency settings */
  function updateVariantPrice(variantID) {
    var $selectedVariant = $('.product-price[data-variant-id="'+variantID+'"]');
    var variantPriceValue = $selectedVariant.attr('data-price-value');
    var compareAtPriceValue = $selectedVariant.attr('data-compare-at-price-value');

    /*
    console.log('updateVariantPrice check price of variantID ='+variantID);
    console.log('compare at price = '+ compareAtPriceValue);
    */

    if (compareAtPriceValue != '' && compareAtPriceValue > variantPriceValue) {
      /*
      console.log('it is on sale!');
      */
      $selectedVariant.find('.old-price').text(Shopify.formatMoney(compareAtPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
      $selectedVariant.find('.price').addClass('new-price').text(Shopify.formatMoney(variantPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
    } else {
      $selectedVariant.find('.old-price').text('');
      $selectedVariant.find('.new-price').removeClass('new-price').text(Shopify.formatMoney(variantPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
    }

    $('.product-cart-details .product-price').removeClass('is-active');
    $selectedVariant.addClass('is-active');
  }

    document.addEventListener("focusin", function() {
    var classList = document.activeElement.classList;
    if (classList) {
      var quantityClassesWhenFocused = ["select2-selection","select2-selection--single"];
      var isQuantityFocused = quantityClassesWhenFocused.every(elementClass => classList.contains(elementClass));
      if (isQuantityFocused) {
        $(".color-variants").attr("tabindex", "0");
        $(".color-variants li").each(function(i, listItem) {
          if (!listItem.classList.contains("out-of-stock")){
            $(this).attr("tabindex", "0");
          }
        });
      }
    }
  }, true);
  document.addEventListener('keydown', function(event) {
    if (event.key == "Enter") {
      event.target.dispatchEvent(new CustomEvent('click'));
    }
  }, false);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  /* Load Select2 Elements */
  $(function(){
    $('#Quantity').select2();
    $('#product-select').select2();
    $(".select2-selection__arrow").remove();
    $(".select2-selection--single").append('<i class="fa fa-angle-down is-active"></i><i class="fa fa-chevron-up"></i>');
    $('#Quantity').on('select2:select', function(e) {
      // console.log('##### qty change' + $('.select-quantity').val());
      $('.add-to-cart').attr('data-cart-quantity',$('.select-quantity').val());
    });
  })

  /* This function needs to live here so it can use liquid for the differnet country currency settings */
  function updateVariantPrice(variantID) {
    var $selectedVariant = $('.product-price[data-variant-id="'+variantID+'"]');
    var variantPriceValue = $selectedVariant.attr('data-price-value');
    var compareAtPriceValue = $selectedVariant.attr('data-compare-at-price-value');

    /*
    // console.log('updateVariantPrice check price of variantID ='+variantID);
    // console.log('compare at price = '+ compareAtPriceValue);
    */

    if (compareAtPriceValue != '' && compareAtPriceValue > variantPriceValue) {
      /*
      // console.log('it is on sale!');
      */
      $selectedVariant.find('.old-price').text(Shopify.formatMoney(compareAtPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
      $selectedVariant.find('.price').addClass('new-price').text(Shopify.formatMoney(variantPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
    } else {
      $selectedVariant.find('.old-price').text('');
      $selectedVariant.find('.new-price').removeClass('new-price').text(Shopify.formatMoney(variantPriceValue,"{% if settings.country_code == 'AU' %}{{ shop.money_with_currency_format }}{% else %}{{ shop.money_format }}{% endif %}"));
    }

    $('.product-cart-details .product-price').removeClass('is-active');
    $selectedVariant.addClass('is-active');
  }

    document.addEventListener("focusin", function() {
    var classList = document.activeElement.classList;
    if (classList) {
      var quantityClassesWhenFocused = ["select2-selection","select2-selection--single"];
      var isQuantityFocused = quantityClassesWhenFocused.every(elementClass => classList.contains(elementClass));
      if (isQuantityFocused) {
        $(".color-variants").attr("tabindex", "0");
        $(".color-variants li").each(function(i, listItem) {
          if (!listItem.classList.contains("out-of-stock")){
            $(this).attr("tabindex", "0");
          }
        });
      }
    }
  }, true);
  document.addEventListener('keydown', function(event) {
    if (event.key == "Enter") {
      event.target.dispatchEvent(new CustomEvent('click'));
    }
  }, false);

  } catch(e) { console.error(e); }
})();

})();
